import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 px-4 md:px-6 bg-white" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-12 text-center" data-id="element-35">
          Who this is for
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-36">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          delay: 0.2
        }} className="bg-cream/50 p-8 rounded-3xl border border-teal/20" data-id="element-37">
            <h3 className="text-xl font-bold text-teal mb-6 flex items-center gap-2" data-id="element-38">
              <Check className="w-6 h-6" data-id="element-39" />
              This is for you if:
            </h3>
            <ul className="space-y-4" data-id="element-40">
              {['You want a meaningful gift that doesn’t become clutter', 'You want to feel close to your grandkid, not just generous', 'You want something you can give instantly (no shipping)', 'You want it to look like a real gift, not a worksheet'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-41">
                  <div className="mt-1 w-1.5 h-1.5 rounded-full bg-teal shrink-0" data-id="element-42" />
                  <span className="text-charcoal" data-id="element-43">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 20
        }} transition={{
          delay: 0.3
        }} className="bg-stone-50 p-8 rounded-3xl border border-stone-200" data-id="element-44">
            <h3 className="text-xl font-bold text-coral mb-6 flex items-center gap-2" data-id="element-45">
              <X className="w-6 h-6" data-id="element-46" />
              This is NOT for you if:
            </h3>
            <ul className="space-y-4" data-id="element-47">
              {['You only want to give expensive physical items', 'You don’t plan to spend time with your grandkid after gifting it'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-48">
                  <div className="mt-1 w-1.5 h-1.5 rounded-full bg-coral shrink-0" data-id="element-49" />
                  <span className="text-charcoal" data-id="element-50">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}